import { Paragraph } from "../../../../atoms";
import { Flex } from "../../../../cores";
import { IconPumpScore } from "../../../../icons";

interface IEnvironmentPointsDescription {
  valueGoodChoice: string;
  valueApproved: string;
}
const EnvironmentPointsDescription = ({
  valueGoodChoice,
  valueApproved,
}: IEnvironmentPointsDescription) => {
  return (
    <>
      <Flex sx={{ marginBottom: "lg" }}>
        <IconPumpScore green value={valueGoodChoice} />
        <Paragraph>Bra val</Paragraph>
      </Flex>
      <Flex>
        <IconPumpScore value={valueApproved} />
        <Paragraph>Godkänt</Paragraph>
      </Flex>
    </>
  );
};

export default EnvironmentPointsDescription;
